'use client';

import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { ProductDetailInformationValue, ProductDetailVariantValue, ProductSetItemValue } from '../../../../../src';
import { getProductSetInfoServerAction } from '../../../../server/lib/productDetail/services/getProductSetInfoServerAction';

export type ProductDetailContextType = {
    productDetails: ProductDetailInformationValue;
    setProductVariantId: (productId: string) => void;
    updateProductDetails: (productDetails: Partial<ProductDetailInformationValue>) => void;
    isLoading: boolean;
    setSelectedProductSetVariants: Dispatch<SetStateAction<Record<number, ProductDetailVariantValue | undefined>>>;
    selectedProductSetVariants: Record<number, ProductDetailVariantValue | undefined>;
    productSetList?: ProductSetItemValue[];
    selectedVariantIds: string[];
    productsSetAvailability: boolean;
    getProductSetInfo: (params: {
        productId: string;
        variantIds: string[];
    }) => ReturnType<typeof getProductSetInfoServerAction>;
};

export const ProductDetailContext = createContext<ProductDetailContextType | undefined>(undefined);

export const useProductDetailContext = () => {
    const context = useContext(ProductDetailContext);
    if (!context) {
        throw new Error('useProductDetailContext must be used within a ProductDetailProvider');
    }
    return context;
};
